export const TABLE_IS_EMPTY = 'No data found.';
export const ITEMS_PER_PAGE = 10;
export const ACTIONS_LABEL = 'Actions';
